let direction = 'ltr';

export const dezThemeSet = [
	{ /* Default */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		headerBg: "color_1",
		navheaderBg: "color_1",
		sidebarBg: "color_1",
		sidebarStyle: "full",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		direction: direction
	},
	{ /* Demo Theme 1 */
		
		typography: "poppins",
		version: "light",
		layout: "horizontal",
		navheaderBg: "color_1",
		headerBg: "color_1",
		sidebarStyle: "full",
		sidebarBg: "color_10",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		primary: "color_10",
		direction: direction
	},
	 { /* Demo Theme 2 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		primary: "color_13",
		headerBg: "color_1",
		navheaderBg: "color_13",
		sidebarBg: "color_1",
		sidebarStyle: "full",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		direction: direction
	},
	{
		/* Demo Theme 3 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		primary: "color_12",
		headerBg: "color_12",
		navheaderBg: "color_12",
		sidebarBg: "color_1",
		sidebarStyle: "full",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		direction: direction
	},
	{
		/* Demo Theme 4 */	
		typography: "poppins",
		version: "dark",
		layout: "vertical",
		primary: "color_3",
		headerBg: "color_1",
		navheaderBg: "color_3",
		sidebarBg: "color_3",
		sidebarStyle: "full",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		direction: direction
	},
	{
		/* Demo Theme 5 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		primary: "color_12",
		headerBg: "color_1",
		navheaderBg: "color_12",
		sidebarBg: "color_12",
		sidebarStyle: "full",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		direction: direction
	},
	{
		/* Demo Theme 6 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		primary: "color_2",
		headerBg: "color_1",
		navheaderBg: "color_2",
		sidebarBg: "color_2",
		sidebarStyle: "mini",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		direction: direction
	},
	
];
	